module.exports = __webpack_public_path__ + "img/lista.4cd12a4d.png";